require('es6-promise').polyfill();
import axios from 'axios';
import * as constants from './constant';

export function signIn(props) {
    const request = axios.post(`${constants.ROOT_URL}/v0/auth/login/`, props)
        .then((response)=>{
            return response
        })
        .catch((err)=>{
            let result = {
                error_signIn: 'error'
            };
            return result
        });

    return{
        type: constants.SIGN_IN,
        payload: request
    }
}

export  function GetUser(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/rest-auth/user/`, config);

    return{
        type: constants.GETUSER,
        payload: request
    }
}

export  function GetDashboard(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/stats/`, config);

    return{
        type: constants.DASHBOARD,
        payload: request
    }
}

export function GetAllUser(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/users/`, config);

    return{
        type: constants.GETALLUSER,
        payload: request
    }
}

export function getUserFilter(token, val) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/users/?search=${val}`, config);

    return{
        type: constants.GETUSERFILTER,
        payload: request
    }
}

export function GetInfoOneUser(id, token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/users/${id}/`, config);

    return{
        type: constants.GETINFOONEUSER,
        payload: request
    }
}

export function GetAdmin(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/users/staff/`, config);

    return{
        type: constants.GETADMIN,
        payload: request
    }
}

export function GetAdminOne(id, token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/users/staff/${id}/`, config);

    return{
        type: constants.GETADMINONE,
        payload: request
    }
}

export function EditAdmin(id, props, token) {
    props.id = parseInt(id);
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/users/staff/${id}/`, props, config);

    return{
        type: constants.EDITADMIN,
        payload: request
    }
}


export function ToggleAdmin(id, data, token) {
    const config = {
        headers: { 'Authorization': `Token ${token}`}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/users/staff/${id}/`, data, config);

    return {
        type: constants.TOGGLEADMIN,
        payload: request
    };
}

export function AddAdmin(token, props) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/users/staff/`, props, config);

    return{
        type: constants.ADDADMIN,
        payload: request
    }
}

export function DelAdmin(id, token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.delete(`${constants.ROOT_URL}/v0/admin/users/staff/${id}/`, config);

    return{
        type: constants.DELADMIN,
        payload: request
    }
}

export function GetLanguage(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/langs/count/`, config);

    return{
        type: constants.GETLANGUAGE,
        payload: request
    }
}

export function GetAllLanguage(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/langs/`, config);

    return{
        type: constants.GETALLLANGUAGE,
        payload: request
    }
}

export function GetOneLanguage(id, token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/langs/${id}/`, config);

    return{
        type: constants.GETONELANGUAGE,
        payload: request
    }
}

export function EditLearningLanguage(id, token, props) {
    let obj = {
        is_active: props
    };
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };

    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/flangs/${id}/`, obj, config);

    return{
        type: constants.EDITLEARNINGLANGUAGE,
        payload: request
    }
}

export function GetOneLearningLanguage(id, token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/flangs/${id}/`, config);

    return{
        type: constants.GETONELEARNINGLANGUAGE,
        payload: request
    }
}

export function AddLang(token, props) {
    let data;
    if(typeof props.flag == 'string'){
        data = props;
        delete data.flag;
    }else{
        data = new FormData();
        data.append('flag', props.flag);
        data.append('code', props.code);
        data.append('name', props.name);
    }
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/langs/`, data, config)
        .then((response)=>{
            return response
        })
        .catch((err)=>{
            let result = {
                error_addLang: err
            };
            return result
        });;

    return{
        type: constants.ADDLANG,
        payload: request
    }
}

export function EditLang(id, props, token) {
    let data;
    if(typeof props.flag == 'string'){
        data = props;
        delete data.flag;
    }else{
        data = new FormData();
        data.append('flag', props.flag);
        data.append('code', props.code);
        data.append('name', props.name);
    }
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/langs/${id}/`, data, config);

    return{
        type: constants.EDITLANG,
        payload: request
    }
}

export function GetForingLang(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/flangs/`, config);

    return{
        type: constants.GETFORINGLANGUAGE,
        payload: request
    }
}

export function AddForingLang(token, props) {
    let data = {
        lang: props
    }
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/flangs/`, data, config);

    return{
        type: constants.ADDFORINGLANGUAGE,
        payload: request
    }
}

export function AddInterfaceLang(token, props) {
    let data = {
        lang: props
    }
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/blangs/`, data, config);

    return{
        type: constants.ADDINTERFACELANGUAGE,
        payload: request
    }
}

export function DelLearningLang(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.delete(`${constants.ROOT_URL}/v0/admin/flangs/${id}/`, config);

    return{
        type: constants.DELFORINGLANGUAGE,
        payload: request
    }
}

export function DeleteLang(id, token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.delete(`${constants.ROOT_URL}/v0/admin/langs/${id}/`, config);

    return{
        type: constants.DELANGUAGE,
        payload: request
    }
}

export function DelInterfaceLang(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.delete(`${constants.ROOT_URL}/v0/admin/blangs/${id}/`, config);

    return{
        type: constants.DELINTERFACELANGUAGE,
        payload: request
    }
}

export function GetInterfaceLang(token, active) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    let request;
    if(active){
        if(active == 'active'){
            request = axios.get(`${constants.ROOT_URL}/v0/admin/blangs/?is_active=True`, config);
        }else{
            request = axios.get(`${constants.ROOT_URL}/v0/admin/blangs/?is_active=False`, config);
        }
    }else{
        request = axios.get(`${constants.ROOT_URL}/v0/admin/blangs/`, config);
    }

    return{
        type: constants.GETINTERFACELANGUAGE,
        payload: request
    }
}

export function GetOneInterfaceLang(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/blangs/${id}/`, config);

    return{
        type: constants.GETONEINTERFACELANGUAGE,
        payload: request
    }
}

export function GetLearningStats(id, token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/lang-stats/${id}/`, config);

    return{
        type: constants.GETLEARNINGSTATS,
        payload: request
    }
}

export function GetStatsChat(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/notification-stats/`, config);

    return{
        type: constants.GETSTATSCHAT,
        payload: request
    }
}

export function saveWord(token, props) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/words/`, props, config)
        .then((response)=>{
            return response
        })
        .catch((err)=>{
            let result = {
                error_word: err
            };
            return result
        });

    return{
        type: constants.SAVEWORD,
        payload: request
    }
}

export function saveWordEdit(token, props, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/words/${id}/`, props, config);

    return{
        type: constants.SAVEWORDEDIT,
        payload: request
    }
}

export function AddChatPerson(token, props) {
    let data;
    if(typeof props.avatar == 'string'){
        data = props;
        delete data.avatar;
    }else{
        data = new FormData();
        data.append('avatar', props.avatar);
        data.append('name', props.name);
    }
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/notification-persons/`, data, config);

    return{
        type: constants.ADDCHATPERSON,
        payload: request
    }
}
export function EditChatPerson(id, props, token) {
    let data;
    if(typeof props.avatar == 'string'){
        data = props;
        delete data.avatar;
    }else{
        data = new FormData();
        data.append('avatar', props.avatar);

        data.append('name', props.name);
    }
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/notification-persons/${id}/`, data, config);

    return{
        type: constants.EDITCHATPERSON,
        payload: request
    }
}
export function GetChatPerson(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/notification-persons/`, config);

    return{
        type: constants.GETCHATPERSON,
        payload: request
    }
}
export function GetChatPersonOne(id, token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/notification-persons/${id}/`, config);

    return{
        type: constants.GETCHATPERSONONE,
        payload: request
    }
}
export function DelChatPerson(id, token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.delete(`${constants.ROOT_URL}/v0/admin/notification-persons/${id}/`, config);

    return{
        type: constants.DELCHATPERSON,
        payload: request
    }
}

export function GetSubscription(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/subscription-stats/`, config);

    return{
        type: constants.GETSUBSCRIPTION,
        payload: request
    }
}

export function GetPackages(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/billing/plans/?flang=${id}`, config);

    return{
        type: constants.GETPACKAGES,
        payload: request
    }
}

export function GetPackageOne(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/billing/plans/${id}/`, config);

    return{
        type: constants.GETPACKAGEONE,
        payload: request
    }
}


export function AddPackage(token, props) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/billing/plans/`, props, config)
        .then((response)=>{
            return response
        })
        .catch((err)=>{
            let result = {
                error: 'error'
            };
            return result
        });

    return{
        type: constants.ADDPACKAGE,
        payload: request
    }
}
export function EditPackage(token, props, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/billing/plans/${id}/`, props, config)
        .then((response)=>{
            return response
        })
        .catch((err)=>{
            let result = {
                error: 'error'
            };
            return result
        });

    return{
        type: constants.EDITPACKAGE,
        payload: request
    }
}
export function delPackage(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.delete(`${constants.ROOT_URL}/v0/admin/billing/plans/${id}/`, config);

    return{
        type: constants.DELPACKAGE,
        payload: request
    }
}

export function getWord(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/words/?flang=${id}`, config);

    return{
        type: constants.GETWORD,
        payload: request
    }
}

export function DelWord(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.delete(`${constants.ROOT_URL}/v0/admin/words/${id}/`, config);

    return{
        type: constants.DELWORD,
        payload: request
    }
}

export function getDetailWord(id, token, flang) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/words/${id}/?flang=${flang}`, config);

    return{
        type: constants.GETDETAILWORD,
        payload: request
    }
}

export function getSentence(token, flang) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/sentences/?flang=${flang}`, config);

    return{
        type: constants.GETSENTENCE,
        payload: request
    }
}

export function getSentenceFilter(token, data) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    let obj = $.param(data)
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/sentences/?${obj}`, config);

    return{
        type: constants.GETSENTENCEFILTER,
        payload: request
    }
}

export function getWordFilter(token, data) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    let obj = $.param(data);
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/words/?${obj}`, config);

    return{
        type: constants.GETWORDFILTER,
        payload: request
    }
}

export function addSentence(token, props) {
    if(props.change_position == ''){
        delete props.change_position
    }
    if(props.grammar == '' || typeof props.grammar == 'string'){
        delete props.grammar
    }
    if(props.pronunciation == '' || typeof props.pronunciation == 'string'){
        delete props.pronunciation
    }
    props.translations = [];

    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/sentences/`, props, config);

    return{
        type: constants.ADDSENTENCE,
        payload: request
    }
}

export function updateSentence(token, props, id) {
    props.translations = [];
    if(props.pronunciation == '' || typeof props.pronunciation == 'string'){
        delete props.pronunciation
    }
    if(props.change_position == ''){
        delete props.change_position
    }
    if(props.grammar == '' || typeof props.grammar == 'string'){
        delete props.grammar
    }
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/sentences/${id}/`, props, config);

    return{
        type: constants.UPDATESENTENCE,
        payload: request
    }
}

export function addNotification(token, props) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/notifications/`, props, config);

    return{
        type: constants.ADDNOTIFICATION,
        payload: request
    }
}

export function updateNotification(token, props, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/notifications/${id}/`, props, config);

    return{
        type: constants.UPDATENOTIFICATION,
        payload: request
    }
}

export function getNotification(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/notifications/${id}/`, config);

    return{
        type: constants.GETNOTIFICATION,
        payload: request
    }
}

export function addTranslationSentense(token, props, id) {
    let request;
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    if(typeof props == 'object'){
        props.sentence = id;
        request = axios.post(`${constants.ROOT_URL}/v0/admin/sentences/translations/`, props, config);
    }else{
        props.forEach((item)=>{
            item.sentence = id;
            if(item.phrase != ''){
                request = axios.post(`${constants.ROOT_URL}/v0/admin/sentences/translations/`, item, config);
            }
        });
    }


    return{
        type: constants.ADDTRANSLATIONSENTENSE,
        payload: request
    }
}

export function updateTranslationSentense(token, props, id) {
    let request;
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    if(typeof props == 'object'){
        request = axios.patch(`${constants.ROOT_URL}/v0/admin/sentences/translations/${id}/`, props, config);
    }else {
        props.forEach((item)=> {
            item.sentence = id;
            if (item.phrase != '') {
                request = axios.patch(`${constants.ROOT_URL}/v0/admin/sentences/translations/${id}/`, item, config);
            }
        });
    }
    return{
        type: constants.UPDATETRANSLATIONSENTENSE,
        payload: request
    }
}

export function getDetailSentense(id, token, flang) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/sentences/${id}/?flang=${flang}`, config);

    return{
        type: constants.GETDETAILSENTENCE,
        payload: request
    }
}

export function delSentense(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.delete(`${constants.ROOT_URL}/v0/admin/sentences/${id}/`, config);

    return{
        type: constants.DELSENTENCE,
        payload: request
    }
}

export function changePosition(token, sentence_id, new_position) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    let data = {
        change_position: new_position
    }
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/sentences/${sentence_id}/`, data, config);
    return {
        type: constants.CHANGEPOSITION,
        payload: request
    }
}

export function PaginationUser(token, page) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/users/?page=${page}`, config);

    return{
        type: constants.PAGINATIONUSER,
        payload: request
    }
}

export function PaginationSentence(token, page, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/sentences/?page=${page}&flang=${id}`, config);

    return{
        type: constants.PAGINATIONSENTENCE,
        payload: request
    }
}

export function paginationLivSituation(token, page, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/live-situations/?page=${page}&flang=${id}`, config);

    return{
        type: constants.PAGINATI_LIV_SITUATIN,
        payload: request
    }
}

export function paginationNotification(token, page) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/sentence-number-notifications/?page=${page}`, config);

    return{
        type: constants.NOTIFICATION,
        payload: request
    }
}

export function GetSentenceStat(id) {
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/sentence/${id}/translations/stat/`);

    return{
        type: constants.GETSENTENCESTAT,
        payload: request
    }
}

export function GetVocabularyStat(id) {
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/word/${id}/translations/stat/`);

    return{
        type: constants.GETVOCABULARYSTAT,
        payload: request
    }
}

export function GetGrammarStat(id) {
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/grammar/${id}/translations/stat/`);

    return{
        type: constants.GETGRAMMARSTAT,
        payload: request
    }
}

export function GetSituationsStat(id) {
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/live-situation/${id}/translations/stat/`);

    return{
        type: constants.GETSITUATIONSSTAT,
        payload: request
    }
}

export function ChangeInterfaceLang(token, obj, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/blangs/${id}/`, obj, config);

    return{
        type: constants.CHANGEINTERFACELANG,
        payload: request
    }
}

export function saveRule(token, props) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/grammar/`, props, config);

    return{
        type: constants.SAVERULE,
        payload: request
    }
}

export function saveRuleEdit(token, props, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/grammar/${id}/`, props, config);

    return{
        type: constants.EDITRULE,
        payload: request
    }
}

export function getGrammarPage(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/grammar/?flang=${id}`, config);

    return{
        type: constants.GETRULE,
        payload: request
    }
}

export function DelRule(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.delete(`${constants.ROOT_URL}/v0/admin/grammar/${id}/`, config);

    return{
        type: constants.DELRULE,
        payload: request
    }
}

export function getDetailRule(id, token, flang) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/grammar/${id}/?flang=${flang}`, config);

    return{
        type: constants.GETDETAILRULE,
        payload: request
    }
}

export function getRuleFilter(token, data) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    let obj = $.param(data);
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/grammar/?${obj}`, config);

    return{
        type: constants.GETRULEFILTER,
        payload: request
    }
}

export function getInterfaceFilter(token, data) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    let obj = $.param(data);
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/reactkeys/?${obj}`, config);

    return{
        type: constants.GETINTERFACEFILTER,
        payload: request
    }
}

export function getInterfaceTranslation(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/reactkeys/`, config);

    return{
        type: constants.GETINTERFACETRANSLATION,
        payload: request
    }
}

export function addInterfaceTranslation(token, props) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/reactkeys/`, props, config);

    return{
        type: constants.ADDINTERFACETRANSLATION,
        payload: request
    }
}

export function editInterfaceTranslation(token, props, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/reactkeys/${id}/`, props, config);

    return{
        type: constants.EDITINTERFACETRANSLATION,
        payload: request
    }
}

export function getSpecialStats(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/sheduled-notifications/translations/stat/`, config);

    return{
        type: constants.GETSPECIALSTATS,
        payload: request
    }
}

export function getSpecialEvents(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/scheduled-notifications/`, config);

    return{
        type: constants.GETSPECIALEVENTS,
        payload: request
    }
}

export function addSpecialEvents(token, props) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/scheduled-notifications/`, props, config);

    return{
        type: constants.ADDSPECIALEVENTS,
        payload: request
    }
}

export function editSpecialEvents(token, props, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/scheduled-notifications/${id}/`, props, config);

    return{
        type: constants.EDITSPECIALEVENTS,
        payload: request
    }
}

export function getOneSpecialEvents(id, token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/scheduled-notifications/${id}/`, config);

    return{
        type: constants.GETONESPECIALEVENTS,
        payload: request
    }
}

export function deleteSpecialEvents(id, token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.delete(`${constants.ROOT_URL}/v0/admin/scheduled-notifications/${id}/`, config);

    return{
        type: constants.DELETEONESPECIALEVENTS,
        payload: request
    }
}

export function GetCoupon(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/billing/coupons/`, config);

    return{
        type: constants.GETCOUPON,
        payload: request
    }
}

export function GetCouponOne(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/billing/coupons/${id}/`, config);

    return{
        type: constants.GETCOUPONONE,
        payload: request
    }
}

export function delCoupon(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.delete(`${constants.ROOT_URL}/v0/admin/billing/coupons/${id}/`, config);

    return{
        type: constants.DELCOUPON,
        payload: request
    }
}

export function AddCoupon(token, props) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/billing/coupons/`, props, config);

    return{
        type: constants.ADDCOUPON,
        payload: request
    }
}

export function EditCoupon(token, props, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/billing/coupons/${id}/`, props, config);

    return{
        type: constants.EDITCOUPON,
        payload: request
    }
}

export function AddStaticPage(token, props) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/staticpages/`, props, config);

    return{
        type: constants.ADDSTATICPAGE,
        payload: request
    }
}

export function EditStaticPage(token, props, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/staticpages/${id}/`, props, config);

    return{
        type: constants.EDITSTATICPAGE,
        payload: request
    }
}

export function delPage(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.delete(`${constants.ROOT_URL}/v0/admin/staticpages/${id}/`, config);

    return{
        type: constants.DELPAGE,
        payload: request
    }
}

export function getStaticPage(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/staticpages/`, config);

    return{
        type: constants.GETSTATICPAGE,
        payload: request
    }
}

export function getPageFilter(token, data) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    let obj = $.param(data);
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/staticpages/?${obj}`, config);

    return{
        type: constants.GETPAGEFILTER,
        payload: request
    }
}

export function getCouponFilter(token, data) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    let obj = $.param(data);
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/billing/coupons/?${obj}`, config);

    return{
        type: constants.GETCOUPONFILTER,
        payload: request
    }
}


export function getChatEventFilter(token, data) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    let obj = $.param(data);
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/scheduled-notifications/?${obj}`, config);

    return{
        type: constants.GETCHATEVENTFILTER,
        payload: request
    }
}

export function getStaticPageOne(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/staticpages/${id}/`, config);

    return{
        type: constants.GETSTATICPAGEONE,
        payload: request
    }
}

export function getStatiPageStats() {
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/static-pages/translations/stat/`);

    return{
        type: constants.GETSTATICPAGESTATS,
        payload: request
    }
}

export function getEmailTemplates(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/mail-templates/types/`, config);

    return{
        type: constants.GETEMAILTEMPLATES,
        payload: request
    }
}

export function getEmailTemplateOne(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/mail-templates/?type=${id}`, config);

    return{
        type: constants.GETEMAILTEMPLATEONE,
        payload: request
    }
}

export function editEmailTemplates(token, id, props) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/mail-templates/${id}/`, props, config);

    return{
        type: constants.EDITEMAILTEMPLATE,
        payload: request
    }
}

export function addEmailTemplates(token, props) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/mail-templates/`, props, config);

    return{
        type: constants.ADDEMAILTEMPLATE,
        payload: request
    }
}

export function getSettings(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/project-settings/`, config);

    return{
        type: constants.GETSETTINGS,
        payload: request
    }
}

export function editSettings(token, props) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };

    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/project-settings/`, props, config);

    return{
        type: constants.EDITSETTINGS,
        payload: request
    }
}

export function editUser(token, props, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };

    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/users/${id}/`, props, config);

    return{
        type: constants.EDITUSER,
        payload: request
    }
}

export function DelUser(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };

    const request = axios.delete(`${constants.ROOT_URL}/v0/admin/users/${id}/`, config);

    return{
        type: constants.EDITUSER,
        payload: request
    }
}


export function PaginationWord(token, flang, page) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/words/?flang=${flang}&page=${page}`, config);

    return{
        type: constants.PAGINATIONWORD,
        payload: request
    }
}

export function addLiveSituations(token, props) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/live-situations/`, props, config).then((response)=>{
        return response
    })
        .catch((err)=>{
            let result = {
                error_situation: err
            };
            return result
        });

    return{
        type: constants.ADDLIVESITUATION,
        payload: request
    }
}

export function getLiveSituations(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/live-situations/?flang=${id}`, config);

    return{
        type: constants.GETLIVESITUATION,
        payload: request
    }
}

export function getDetailSituation(id, token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/live-situations/${id}/`, config);

    return{
        type: constants.GETONELIVESITUATION,
        payload: request
    }
}

export function deleteLiveSituations(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.delete(`${constants.ROOT_URL}/v0/admin/live-situations/${id}/`, config);

    return{
        type: constants.DELLIVESITUATION,
        payload: request
    }
}

export function updateLiveSituations(token, props, id) {
    let config = {
        headers: {
            'Authorization': 'Token ' + token
        }
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/live-situations/${id}/`, props, config);

    return{
        type: constants.UPDATELIVESITUATION,
        payload: request
    }
}

export function addTranslationLiveSituations(token, props, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/live-situations/translations/`, props, config);

    return{
        type: constants.ADDTRANSLATIONLIVESITUATION,
        payload: request
    }
}

export function updateTranslationLiveSituations(token, props, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/live-situations/translations/${id}/`, props, config);

    return{
        type: constants.UPDATETRANSLATIONLIVESITUATION,
        payload: request
    }
}

export function getSituationFilter(token, data) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    let obj = $.param(data);
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/live-situations/?${obj}`, config);

    return{
        type: constants.GETSITUATIONFILTER,
        payload: request
    }
}

export function getSituationSelect(token, flang, sentence) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    let request;
    if(sentence){
        request = axios.get(`${constants.ROOT_URL}/v0/admin/live-situations-list/${flang}/?sentence=${sentence}`, config);
    }else{
        request = axios.get(`${constants.ROOT_URL}/v0/admin/live-situations-list/${flang}/`, config);
    }

    return{
        type: constants.GETSITUATIONSELECT,
        payload: request
    }
}

export function getNotificationList(token) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/sentence-number-notifications/`, config);

    return{
        type: constants.NOTIFICATION,
        payload: request
    }
}

export function getNotificationOne(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.get(`${constants.ROOT_URL}/v0/admin/sentence-number-notifications/${id}/`, config);

    return{
        type: constants.NOTIFICATIONONE,
        payload: request
    }
}

export function addNotificationBig(token, props) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/sentence-number-notifications/`, props, config);

    return{
        type: constants.NOTIFICATIONADD,
        payload: request
    }
}

export function updateNotificationBig(token, props, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/sentence-number-notifications/${id}/`, props, config);

    return{
        type: constants.NOTIFICATIONUPDATE,
        payload: request
    }
}

export function addTranslationToNotifications(token, props) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.post(`${constants.ROOT_URL}/v0/admin/sentence-number-notifications/translations/`, props, config);

    return{
        type: constants.NOTIFICATIONADDTRANSLATION,
        payload: request
    }
}

export function updateTranslationToNotifications(token, props, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.patch(`${constants.ROOT_URL}/v0/admin/sentence-number-notifications/translations/${id}/`, props, config);

    return{
        type: constants.NOTIFICATIONUPDATETRANSLATION,
        payload: request
    }
}

export function deleteNotification(token, id) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    const request = axios.delete(`${constants.ROOT_URL}/v0/admin/sentence-number-notifications/${id}/`, config);

    return{
        type: constants.DELLETENOTIFICATION,
        payload: request
    }
}

export function getNotificationSelect(token, flang, sentence) {
    let config = {
        headers: {'Authorization': 'Token ' + token}
    };
    let request;
    if(sentence){
        request = axios.get(`${constants.ROOT_URL}/v0/admin/sentence-number-notification-list/${flang}/?sentence=${sentence}`, config);
    }else{
        request = axios.get(`${constants.ROOT_URL}/v0/admin/sentence-number-notification-list/${flang}/`, config);
    }

    return{
        type: constants.GETNOTIFICATIONSELECT,
        payload: request
    }
}



// WEBPACK FOOTER //
// ./src/actions/index.js